<style>

.amenities {
    font-size: 1rem;
    margin-top: 6rem;
}

.amenities .amenities-header {
    border-bottom: 1px solid white;
    margin-bottom: 1rem;
}

.amenities .lounge-header {

    margin-bottom: 1rem;
}


</style>

<template>

<div class="px-4 lg:px-24 xl:px-32 mx-auto ">

    <div class="flex flex-col justify-center amenities">

        <div class="flex flex-wrap mb-16 lg:mb-0">

            <div class="w-full lg:w-1/5 self-center">

                <p class="amenities-header uppercase">Tenant Exclusive Lounge</p>
                <p class="text-gray">Located on the lobby level, the lounge features two semi-private areas that can also be utilized for informal meetings and events. Coffee and beverage service available.
                </p>

            </div>
            <div class="w-full lg:w-4/5 p-2 lg:p-10 order-first lg:order-last">
                <div class="my-2">
                    <br /> <img src="/images/amenities/amenities-2.jpg" class="w-full" />
                  </div>
            </div>


        </div>

        <div class="flex flex-wrap mb-16 lg:mb-0">

          <div class="w-full lg:w-1/5  self-center order-2 lg:order-1">
              <p class="amenities-header uppercase">Lower Level<br/>Conference Center</p>

              <p class="text-gray">Space is flexible from a 26-person boardroom into two separate 8-person meeting rooms. The conference center features catering support.
              </p>

          </div>


          <div class="w-full lg:w-4/5 p-4 lg:p-10  order-1 lg:order-2">
              <img src="/images/new-photos/conftable.jpg" />
          </div>

        </div>

          <div class="flex flex-wrap mb-16 lg:mb-0">


            <div class="hidden lg:block w-1/5  self-center order-3 lg:order-1">

            </div>

            <div class="w-full lg:w-2/5 p-4 lg:p-10  order-1 lg:order-1">
                <img src="/images/amenities/lowerlevel1.png" /><br/>
                  <img src="/images/amenities/confroom1.png" />
            </div>

            <div class="w-full lg:w-2/5 p-4 lg:p-10  order-2 lg:order-2">

              <img src="/images/amenities/lowerlevel2.png" /><br/>
                    <img src="/images/amenities/confroom2.png" />
            </div>

          </div>

        </div>




    </div>

</div>

</template>

<script>

export default {
    name: 'amenities',
}

</script>
